const scrollToElementById = (id: string, duration = 500) => {
  const element = document.getElementById(id);
  if (element) {
    const { top } = element.getBoundingClientRect();
    const startPos = window.scrollY;
    const diff = top;
    let startTime = 0;
    let requestId: number;

    const loop = (currentTime: number) => {
      if (!startTime) {
        startTime = currentTime;
      }

      // Elapsed time in miliseconds
      const time = currentTime - startTime;

      const percent = Math.min(time / duration, 1);
      window.scrollTo(0, startPos + diff * percent - 70);

      if (time < duration) {
        // Continue moving
        requestId = window.requestAnimationFrame(loop);
      } else {
        window.cancelAnimationFrame(requestId);
      }
    };
    requestId = window.requestAnimationFrame(loop);
  }
};

export default scrollToElementById;
